import React, { useContext, useMemo } from 'react';
import { RootStore } from '../stores';
import { usePxtraApiClient } from './usePxtraApiClient';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

const storesContext = React.createContext<RootStore | null>(null);

export const RootStoreProvider = ({ children }: React.PropsWithChildren) => {
  const apiClient = usePxtraApiClient();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const rootStore = useMemo(() => new RootStore(apiClient, navigate, t), []);

  return <storesContext.Provider value={rootStore}>{children}</storesContext.Provider>;
};

export const useStore = () => {
  const rootStore = useContext(storesContext);
  if (!rootStore) {
    throw new Error('No root store');
  }

  return rootStore;
};
